module.exports = __webpack_public_path__ + "img/SKMJ_etc9.3a117c28.jpg";